import { Link } from 'react-router-dom';
import { Calendar, MapPin, Clock, User } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import type { Job } from '../lib/store';
import StatusBadge from './StatusBadge';
import { statusColor } from '../lib/utils';

export default function JobCard({ job }: { job: Job }) {
  const c = statusColor(job.status);
  const barColor = c.text.replace('text-', 'bg-');
  return (
    <Link
      to={`/jobs/${job.id}`}
      className="card p-4 hover:shadow-pop hover:-translate-y-0.5 transition-all duration-150 group block relative overflow-hidden"
      data-testid={`job-card-${job.id}`}
    >
      <div className={`absolute inset-y-0 left-0 w-1 ${barColor} opacity-80`} />
      <div className="pl-2">
        <div className="flex items-start justify-between gap-3 mb-1.5">
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 mb-1">
              {job.job_number && (
                <span className="text-[10px] font-bold text-slate-400 tracking-wider">
                  {job.job_number}
                </span>
              )}
              <StatusBadge status={job.status} size="sm" />
            </div>
            <h3 className="font-semibold text-slate-900 truncate group-hover:text-brand-700 transition">
              {job.title}
            </h3>
            {job.client_name && (
              <div className="text-sm text-slate-500 truncate mt-0.5">{job.client_name}</div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 mt-3 text-xs text-slate-500">
          <div className="flex items-center gap-1.5 min-w-0">
            <Calendar className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">
              {job.date ? format(parseISO(job.date), 'EEE d MMM') : '—'}
            </span>
          </div>
          {job.time && (
            <div className="flex items-center gap-1.5 min-w-0">
              <Clock className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{job.time}</span>
            </div>
          )}
          {job.assigned_to && (
            <div className="flex items-center gap-1.5 min-w-0">
              <User className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{job.assigned_to}</span>
            </div>
          )}
          {job.client_address && (
            <div className="flex items-center gap-1.5 min-w-0 col-span-2">
              <MapPin className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{job.client_address}</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
